import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const signoz = defineConnector({
  identifier: "signoz",
  name: "SigNoz",
  tagLine: "Open source observability platform",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.signoz.io/.*",
  auth: (app) =>
    headerAuth([{ name: "SIGNOZ-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your SigNoz instance URL",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-instance.signoz.io",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In SigNoz, go to **Settings › API Keys** and create a new key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${domain}/api/v2/services`,
      method: "POST" as const,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ start: 0, end: 0 }),
      expectedStatus: [200, 400],
    }),
  },
});
